import { CheckCircle2, XCircle, Info, AlertTriangle, X } from 'lucide-react';
import { useToastStore, type Toast } from '@/stores/toastStore';

const config = {
  success: {
    icon: CheckCircle2,
    classes: 'border-emerald-500/40 bg-emerald-500/10 text-emerald-400',
  },
  error: {
    icon: XCircle,
    classes: 'border-red-500/40 bg-red-500/10 text-red-400',
  },
  info: {
    icon: Info,
    classes: 'border-blue-500/40 bg-blue-500/10 text-blue-400',
  },
  warning: {
    icon: AlertTriangle,
    classes: 'border-amber-500/40 bg-amber-500/10 text-amber-400',
  },
} as const;

function ToastItem({ toast }: { toast: Toast }) {
  const dismiss = useToastStore((s) => s.dismiss);
  const { icon: Icon, classes } = config[toast.type];

  return (
    <div
      className={`animate-in flex items-start gap-3 w-full rounded-lg border p-4 shadow-lg ${classes}`}
    >
      <Icon className="h-5 w-5 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-surface-100">{toast.title}</p>
        {toast.description && (
          <p className="mt-1 text-xs text-surface-400">{toast.description}</p>
        )}
      </div>
      <button
        onClick={() => dismiss(toast.id)}
        className="shrink-0 p-0.5 rounded text-surface-500 hover:text-surface-300 transition-colors"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 w-80">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} />
      ))}
    </div>
  );
}
